'use client';

import React, { useEffect, useState } from 'react';

import WeddingNav from '@/components/WeddingNav';
import GuestDashboardLogin from './components/GuestDashboardLogin';
import GuestDashboardView from './components/GuestDashboardView';
import { createClient } from '@/lib/supabase/client';

export default function GuestDashboardPage() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const supabase = createClient();

  useEffect(() => {
    supabase?.auth?.getSession()?.then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    const { data: { subscription } } = supabase?.auth?.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => subscription?.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase?.auth?.signOut();
    setUser(null);
  };

  if (loading) {
    return (
      <main className="bg-buttermilk min-h-screen">
        <WeddingNav />
        <div className="flex items-center justify-center min-h-[60vh]">
          <svg className="animate-spin w-6 h-6 text-warm-sand" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
      </main>
    );
  }

  return (
    <main className="bg-buttermilk min-h-screen">
      <WeddingNav />
      {user ? (
        <GuestDashboardView user={user} onSignOut={handleSignOut} />
      ) : (
        <GuestDashboardLogin onLogin={setUser} />
      )}
    </main>
  );
}
